/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { RequiredApplicationFieldSource } from './requiredApplicationFieldSource';

/**
 * Serializable RequiredField for the application-answers fill sheet (#20).
 *
 * Partial spike: screening-only. EEO fields may appear with ``sensitive=True``
 * (FE must skip). Unsupported types have ``renderable=False``.
 *
 * SELECT / MULTI_SELECT options are not yet carried from Kombo through
 * ``NormalizedScreeningQuestion`` — FE uses a text-input fallback for those
 * types in v1.
 */
export interface RequiredApplicationField {
  id: string;
  label: string;
  type: string;
  required: boolean;
  blankable: boolean;
  source: RequiredApplicationFieldSource;
  sensitive?: boolean;
  renderable?: boolean;
  display_type?: string | null;
}
